import { EmptyState } from '@c42/component-library';
import { BrandColors } from '@c42/material-ui-theme';
import { Box, Button } from '@mui/material';
import { AlertCircle } from 'mdi-material-ui';
import React from 'react';
import Text from '../../shared/Text';
import { performRedirect } from '../utils/performRedirect';
import { getTryAgainRedirectUrl } from '../utils/redict-url';
import CommonStaticLayout from './common-static-layout';

const SsoAuthLoginIncorrectTryAgain: React.FC = () => {
  const redirectUrlParam = getTryAgainRedirectUrl();

  React.useEffect(() => {
    document.title = Text.get('sso_doc_title_error');
  }, []);

  const handleTryAgain = () => {
    if (redirectUrlParam) {
      performRedirect(redirectUrlParam);
    }
  };

  return (
    <CommonStaticLayout noPadding>
      <EmptyState
        icon={<AlertCircle htmlColor={BrandColors.BoldBlue} />}
        title={Text.get('ssoAuthSignIn_incorrect_message1')}
        subtitle={Text.get('ssoAuthSignIn_incorrect_message2_alt')}
        PaperProps={{ elevation: 0 }}
      >
        {redirectUrlParam && (
          <Box mt={2.5}>
            <Button id="try-again-btn" variant="contained" onClick={handleTryAgain}>
              {Text.get('ssoAuthSignIn_try_again')}
            </Button>
          </Box>
        )}
      </EmptyState>
    </CommonStaticLayout>
  );
};

export default SsoAuthLoginIncorrectTryAgain;
